import apiClient from "./ApiService";
import { PATH_DISTRICT } from "../config/env";

export const getDistrics = async()=>{
    return await apiClient.get(PATH_DISTRICT);
}
export default getDistrics;